import {LoginWrapper} from "@/components/login";
import {LoginCard} from "@/components/cards";
import * as cookie from "cookie";
import {isEmpty} from "@/utils/global-functions";
import Head from "next/head";

export default function Freelancer() {

    return (
        <>
            <Head>
                <title>پل دیزاینرز | ورود و ثبت نام</title>
            </Head>
            <LoginWrapper classes={{
                bgClasses: "bg-pol-light-orange-8 after:bg-pol-cream-2",
                headerClasses: "bg-pol-cream-2",
            }}>
                <LoginCard
                    userType={1}
                    overlayClasses="bg-gradient-to-bl from-pol-orange to-pol-orange-dark"
                />
            </LoginWrapper>
        </>
    )
}

export async function getServerSideProps({req}) {
    let loggedIn = false;
    try {
        const cookies = cookie.parse(req.headers.cookie);
        loggedIn = !isEmpty(cookies) && cookies[process.env.NEXT_PUBLIC_FREELANCER_TOK];
    } catch (e) {
        console.log(e)
    }

    if(loggedIn) {
        return {
            redirect: {
                permanent: false,
                destination: "/"
            },
            props: {}
        }
    }
    return {
        props: {}
    }
}
